import { render, staticRenderFns } from "./CancelledCalls.vue?vue&type=template&id=99354dac&"
import script from "./CancelledCalls.vue?vue&type=script&lang=js&"
export * from "./CancelledCalls.vue?vue&type=script&lang=js&"
import style0 from "./CancelledCalls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports